// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'

export default {
  MenuBuildWithUs: codeSplit({
    l10n: {},
    loadComponent: () =>
      import(
        /* webpackChunkName: "MenuBuildWithUs" */
        './index'
      ),
  }),
}
